import ShpWrite from "./shapefile";
import JSZip from "jszip";

const defaultOptions = {
  device: {
    shapefile: (
      name = "layers",
      point = "points",
      polygon = "polygons",
      line = "lines"
    ) => ({
      folder: name,
      types: {
        point,
        polygon,
        line,
      },
    }),

    shapefileGroup: (group = "layers", ...names) => ({
      folder: group,
      names,
    }),
  },
};

/*  Common exportation tool, when the data type doesn't matter 
    to the method. */
const any = {
  /* User's computer */
  toDevice: {
    /* triggers download */
    trigger: (blob, filename) => {
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = filename;

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  } /* toDevice */,
};

/* Export DataView based shapefile ({shp, .shx, .dbf}) */
const shapefile = {
  toDevice: {
    asZippedFolder: (shapefiles, options) => {
      const zip = new JSZip();
      const layers = zip.folder(options.folder);

      shapefiles.forEach((shapefile, i) => {
        layers.file(options.names[i] + ".shp", shapefile.shp.buffer, {
          binary: true,
        });
        layers.file(options.names[i] + ".shx", shapefile.shx.buffer, {
          binary: true,
        });
        layers.file(options.names[i] + ".dbf", shapefile.dbf.buffer, {
          binary: true,
        });
        layers.file(
          options.names[i] + ".prj",
          `GEOGCS["WGS 84",DATUM["WGS_1984",SPHEROID["WGS 84",6378137,298.257223563,AUTHORITY["EPSG","7030"]],AUTHORITY["EPSG","6326"]],PRIMEM["Greenwich",0,AUTHORITY["EPSG","8901"]],UNIT["degree",0.0174532925199433,AUTHORITY["EPSG","9122"]],AUTHORITY["EPSG","4326"]]`
        );
        layers.file(options.names[i] + ".cpg", "ISO-8859-1");

        if (options.styles && options.styles[i]) {
          layers.file(options.names[i] + ".qml", options.styles[i]);
        }
      });

      zip
        .generateAsync({ type: "blob", compression: "STORE" })
        .then((zipped) => {
          any.toDevice.trigger(zipped, options.folder + ".zip");
        });
    },
  } /* toDevice */,
};

/* FeatureCollection */
const table = {
  /* Export (convert) a feature collection into a shapefile */
  toShapefile: {
    one: (collection) => {
      const [shapes] = ShpWrite.segregate(collection);
      const buffer = [];
      /* ShpWrite uses callback even though the function is synchronous */
      ShpWrite.write(
        shapes.properties,
        shapes.type,
        shapes.geometries,
        (err, res) => {
          /* err is always null */
          buffer.push(res);
        }
      );
      const [shapefile] = buffer;

      return shapefile;
    },

    many: (collections) => {
      return collections.map((collection) => {
        return table.toShapefile.one(collection);
      });
    },
  } /* toShapefile */,

  toDevice: {
    asShapefile: (collection, options = defaultOptions.device.shapefile()) => {
      ShpWrite.download(collection, options);
    },

    asShapefileGroup: (
      collections,
      options = defaultOptions.device.shapefileGroup()
    ) => {
      console.log("index.js => asShapefileGroup - 1");
      const shapefiles = table.toShapefile.many(collections);
      console.log("index.js => asShapefileGroup - 2");
      shapefile.toDevice.asZippedFolder(shapefiles, options);
      console.log("index.js => asShapefileGroup - 3");
    },
  } /* toDevice */,
};

export default { defaultOptions, any, shapefile, table };
